import { render, staticRenderFns } from "./Measurements.vue?vue&type=template&id=d916d3aa&scoped=true&"
import script from "./Measurements.vue?vue&type=script&lang=js&"
export * from "./Measurements.vue?vue&type=script&lang=js&"
import style0 from "./Measurements.vue?vue&type=style&index=0&id=d916d3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d916d3aa",
  null
  
)

export default component.exports